export var CrossTabPushMessageType;
(function (CrossTabPushMessageType) {
    CrossTabPushMessageType["onAuthStatusChanged"] = "onAuthStatusChanged";
    CrossTabPushMessageType["onSetLoginGuardianResult"] = "onSetLoginGuardianResult";
    CrossTabPushMessageType["onAddGuardianResult"] = "onAddGuardianResult";
    CrossTabPushMessageType["onRemoveGuardianResult"] = "onRemoveGuardianResult";
    CrossTabPushMessageType["onEditGuardianResult"] = "onEditGuardianResult";
    CrossTabPushMessageType["onGuardianApprovalResult"] = "onGuardianApprovalResult";
    CrossTabPushMessageType["onCheckSellResult"] = "onCheckSellResult";
    CrossTabPushMessageType["onTransferSettingApproval"] = "onTransferSettingApproval";
    CrossTabPushMessageType["onSendOneTimeApproval"] = "onSendOneTimeApproval";
})(CrossTabPushMessageType || (CrossTabPushMessageType = {}));
